const actionTypes = {
  FetchReviewStatus: 'FETCH_REVIEW_STATUS',
};

export default actionTypes;
